<info-modal [title]="title" (onOk)="ok()">
	<loading [isLoad]="statsLoader || !stats"></loading>
	<table class="table">
		<thead>
			<tr>
				<th>item</th>
			</tr>
		</thead>

		<tbody>
			<tr *ngFor="let stat of stats">
				<td>
					<gotosupport
						[queryParams]="{userId: stat._id, email: stat.email}"
					>
						{{ stat.email || stat.username }}
					</gotosupport>
				</td>
			</tr>
		</tbody>
	</table>
</info-modal>
